module.exports = __webpack_public_path__ + "static/img/5.7820dec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/eng/5.png
// module id = 4f/t
// module chunks = 0